/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'quiz',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      courseId: '',
      QuizListDetails:null,
      removeQuizId:'',
      addquiz: null,
      isActive: false,
      is_active: false,
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDataState',
      'getQuizDetailsByIdDataState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  mounted() {
    this.courseId = this.$route.params.id;
    this.$store.dispatch('getQuizByCourseFun', {id : this.$route.params.id}).then((res) => {
      this.QuizListDetails = this.$store.getters.getQuizDataState.data
    })
  },
  methods: {
    geQuizListAgain() {
      this.$store.dispatch('getQuizByCourseFun', {id : this.$route.params.id}).then((res) => {
        this.QuizListDetails = this.$store.getters.getQuizDataState.data
      }).catch((err) => {})
    },
    courseQuizStatusAct(quizId) {
      let data = {
        id: quizId
      }
      this.$store.dispatch('getQuizDetailsByIdFun', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
            if (this.isActive === true) {
              this.is_active = false
            }
            if (this.isActive === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizListAgain();
                toast.success("Quiz Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    removeQuizagain(id) {
      $('#removQuizModalAgain').modal();
      this.removeQuizId = id
    },
    RemoveQuizConfirmationagain(){
      this.$store.dispatch('removeQuizFun', {
        id: this.removeQuizId
      }).then((res) => {
        this.geQuizListAgain()
      }).catch((err) => {})
    }
  },
  beforeMount() {
  },
  watch: {
  }
}